import Axios from "@app/api/axios";
import { WATCH_LISTS } from "@utils/constant";

const getWatchLists = (payload) => Axios.get(WATCH_LISTS, { params: payload });

export default getWatchLists;
